import { render, staticRenderFns } from "./CoverImage.vue?vue&type=template&id=8f9b0198&scoped=true&"
import script from "./CoverImage.vue?vue&type=script&lang=js&"
export * from "./CoverImage.vue?vue&type=script&lang=js&"
import style0 from "./CoverImage.vue?vue&type=style&index=0&id=8f9b0198&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9b0198",
  null
  
)

export default component.exports